// extracted by mini-css-extract-plugin
export default {"paper":"Paper_paper__bXZY3"};